export default __webpack_public_path__ + "static/media/eye.96fe3b7f.svg";